export default __webpack_public_path__ + "static/media/Support.5f8d1e57.svg";